/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypePictureIcon16Solid = forwardRef('FileTypePictureIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.597 1.586A2 2 0 0 0 9.182 1H4.5A2.5 2.5 0 0 0 2 3.5v9A2.5 2.5 0 0 0 4.5 15h7a2.5 2.5 0 0 0 2.5-2.5V5.817a2 2 0 0 0-.586-1.414l-2.817-2.817ZM7 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm1.593 3.664a.5.5 0 0 1 .707 0l1.483 1.483a.75.75 0 0 0 1.06-1.06l-1.482-1.483a2 2 0 0 0-2.829 0l-3.375 3.375a.75.75 0 0 0 1.06 1.061l3.376-3.376Z" })));
});
